import { GenericService } from './generic.service';
import { DiagnosisStatus } from '@/models';

export class DiagnosisStatusService extends GenericService<DiagnosisStatus> {
  constructor() {
    super('v1/diagnosis-statuses');
  }
}
